import * as Yup from 'yup';
let validationSchema = Yup.object({
  otp: Yup.string()
    .required('page.otp_verification_otp_required')
    .matches(/^[0-9\s]+$/, 'page.otp_verification_otp_matches')
});
export default validationSchema;